import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  Button,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import profile from "../assets/images/profile.jpg";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import { Link } from "react-router-dom";
import "./Profile.css";
import Header from "../Common/Header/Header";
const Profile = (props) => {
  const { buttonLabel, className } = props;
  const [modal, setModal] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = () => {
    setUserInfo(JSON.parse(localStorage.getItem("user")));
  };

  const toggle = () => setModal(!modal);
  return (
    <>
      <Header />
      <section className="gradient-form">
        <Container className="profileContainer">
          <Row className="d-flex justify-content-center align-items-center h-100">
            <Col lg={10} md={12} sm={12}>
              <Card className="rounded-3 text-black">
                <Row>
                  <Col lg={12}>
                    <CardBody>
                      <div className="text-center">
                        <img
                          className="profile-imgg"
                          src={profile}
                          alt="profile-imgg"
                        />
                        <div className="p-image">
                          <AddAPhotoIcon
                            className="upload-button"
                            onClick={toggle}
                          />
                          <Modal
                            isOpen={modal}
                            toggle={toggle}
                            className={className}
                          >
                            <ModalHeader toggle={toggle}>
                              <h5
                                className="modal-title"
                                id="exampleModalLongTitle"
                              >
                                Choose Profile pic
                              </h5>
                            </ModalHeader>
                            <ModalBody>
                              <div class="button-wrapper">
                                <span class="label">Upload File</span>
                                <Input
                                  type="file"
                                  name="upload"
                                  id="upload"
                                  class="upload-box"
                                  placeholder="Upload File"
                                />
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={toggle}>
                                Close
                              </Button>{" "}
                              <Button color="primary" onClick={toggle}>
                                Save Changes
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </div>
                      </div>
                      <form>
                        <div className="form-outline mb-2">
                          <label className="form-label" for="form2Example11">
                            Username
                          </label>
                          <input
                            type="email"
                            id="form2Example11"
                            value={userInfo.firstName}
                            className="form-control"
                            placeholder="Username"
                          />
                          <span></span>
                        </div>

                        <div className="form-outline mb-2">
                          <label
                            className="form-label"
                            htmlfor="form2Example22"
                          >
                            Password
                          </label>
                          <input
                            type="password"
                            id="form2Example22"
                            value={userInfo.password}
                            className="form-control"
                            placeholder="Password"
                          />
                          <span></span>
                        </div>
                        <div className="form-outline mb-2">
                          <label
                            className="form-label"
                            htmlfor="form2Example22"
                          >
                            Email
                          </label>
                          <input
                            type="Email"
                            id="form2Example22"
                            value={userInfo.email}
                            className="form-control"
                            placeholder="Email"
                          />
                          <span></span>
                        </div>

                        <div className="text-center pt-1 mb-2 pb-1">
                          <Link to="/redem">
                            <button className="btn login_btn" type="button">
                              Submit
                            </button>
                          </Link>
                        </div>
                      </form>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default Profile;
